import React from "react";

function BottomColContent2(props) {
  
  return(
        <div className={"bottomColContent bottomColContent2 textModule1 Orangeh6 " + props.CustomClass}>
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-xl-6 col-md-8 col-lg-7 text-left align-self-center">
                        <div
                        dangerouslySetInnerHTML={{
                        __html: props.content
                        }}></div>
                    </div>
                    <div className="col-xl-5 col-md-4 col-lg-4 mt-5 mt-md-0">
                        <div className="Imgbg" data-aos="fade-up">
                            <img  data-aos="fade-up" src={props.image?.url} alt={props.image?.alt} style={{width:`100%`}}></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
}
export default BottomColContent2;